import React, { Component } from 'react'
import Select from 'react-select';

import PropTypes from 'prop-types';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';

import Dialog from 'material-ui/Dialog';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import Subheader from 'material-ui/Subheader';
import TextField from 'material-ui/TextField';

import ReactEcharts from 'components/ReactECharts';
import CHARTCONFIG from 'constants/ChartConfig';

import { Tabs, Tab } from 'material-ui/Tabs';
import SwipeableViews from 'react-swipeable-views';

import $ from 'jquery';

var options = [];

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

const MONTH_NAMES = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
};

var MAX_MONTHS = 4;

var CHART_TEMPLATE = {
  loading: true,
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: [""],
    textStyle: {
      color: CHARTCONFIG.color.text
    }
  },
  toolbox: {
    show: true,
    feature: {
      saveAsImage: { show: true, title: 'save' }
    }
  },
  calculable: true,
  dataZoom: {
    show: true,
    realtime: true,
    //orient: 'vertical',   // 'horizontal'
    //x: 0,
    y: 36,
    //width: 400,
    height: 20,
    //backgroundColor: 'rgba(221,160,221,0.5)',
    //dataBackgroundColor: 'rgba(138,43,226,0.5)',
    //fillerColor: 'rgba(38,143,26,0.6)',
    //handleColor: 'rgba(128,43,16,0.8)',
    //xAxisIndex:[],
    //yAxisIndex:[],
    //start : 40,
    //end : 60
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: [],
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      splitLine: {
        lineStyle: {
          color: CHARTCONFIG.color.splitLine
        }
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      axisLabel: {
        formatter: '{value} W',
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      splitLine: {
        lineStyle: {
          color: CHARTCONFIG.color.splitLine
        }
      },
      splitArea: {
        show: true,
        areaStyle: {
          color: CHARTCONFIG.color.splitArea
        }
      }
    }
  ],
  series: [
    {
      name: 'Power',
      type: 'line',
      data: [],
      markPoint: {
        data: [
          { type: 'max', name: 'Max' },
          { type: 'min', name: 'Min' }
        ]
      },
      markLine: {
        data: [
          { type: 'average', name: 'Average' }
        ]
      }
    }
  ]
};

export default class RoomPower extends Component {
  constructor(props) {
    super(props);
    this.state = {
      all_rooms: [],
      all_rooms_copy: [],
      ch_in_time: new Date(),
      maxDate: new Date(),
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      search_field: "",
      current_devices: [],
      current_switches: {},
      switchHistory: [],
      room_energy: 0,
      slideIndex: 0,
      all_months: [],
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      },
      room_line_today: {
        loading: true,
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ["Today's Power Consumption"],
          textStyle: {
            color: CHARTCONFIG.color.text
          }
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              show: true,
              title: 'Save',
              name: 'AllData'
            },
            dataView : {
              show: true, 
              readOnly: true,
              title: 'View',
              lang: [
                "Hourly Power Consumptions Report ",
                "Close",
              ],
              buttonColor: "rgb(0, 188, 212)"
            }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            boundaryGap: true, // adds gap on both sides of axis
            data: [],
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: CHARTCONFIG.color.text
              },
              rotate: 45, // rotates the label
              interval: 0 // to set the interval zero so all labels are displayed
            },
            splitLine: {
              lineStyle: {
                color: CHARTCONFIG.color.splitLine
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} units',
              textStyle: {
                color: CHARTCONFIG.color.text
              }
            },
            splitLine: {
              lineStyle: {
                color: CHARTCONFIG.color.splitLine
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: CHARTCONFIG.color.splitArea
              }
            }
          }
        ],
        series: [
          {
            name: 'Energy',
            type: 'bar',
            data: [],
            barWidth: 25,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [
                { type: 'average', name: 'Average' }
              ]
            }
          }
        ]
      },
      room_line_day_of_month: {
        loading: true,
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ["Power Consumption"],
          textStyle: {
            color: CHARTCONFIG.color.text
          }
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              show: true,
              title: 'save',
              name: ''
            },
            dataView : {
              show: true, 
              readOnly: true,
              title: 'View',
              lang: [
                "Hourly Power Consumptions Report ",
                "Close",
              ],
              buttonColor: "rgb(0, 188, 212)"
            }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            boundaryGap: true, // adds gap on both sides of axis
            data: [],
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: CHARTCONFIG.color.text,
              },
              rotate: 45,
              interval: 0
            },
            splitLine: {
              lineStyle: {
                color: CHARTCONFIG.color.splitLine
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} units',
              textStyle: {
                color: CHARTCONFIG.color.text
              }
            },
            splitLine: {
              lineStyle: {
                color: CHARTCONFIG.color.splitLine
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: CHARTCONFIG.color.splitArea
              }
            }
          }
        ],
        series: [
          {
            name: 'Energy',
            type: 'bar',
            data: [],
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [
                { type: 'average', name: 'Average' }
              ]
            }
          }
        ]
      },
      devicesSelected: '-1',
      renderGraph: true,
      showHistory: true,
    }
  }

  componentDidMount() {
    this.getAllRooms(this.state.current_offset);
  }

  getAllRooms() {
    ds.getSomeRooms(ls.getUserDetails().hotel_id, 0, 0,
      data => {
        this.setState({
          all_rooms: data,
          all_rooms_copy: data.slice(),
          totalCount: data.length
        });

      }, err => { }
    )
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }

  setImageDetails(roomId) {
    if (roomId === -1) {
      this.state.room_line_today.toolbox.feature.saveAsImage.name = 'ALL' + ' - ' + new Date().toDateString();
      this.state.room_line_day_of_month.toolbox.feature.saveAsImage.name = 'ALL';

    } else {
      this.state.all_rooms.forEach((roomPresent) => {
        if (roomPresent.hotel_room_id._id.toString() == roomId.toString()) {
          const roomName = roomPresent.hotel_room_id.name;
          const dateSelected = new Date().toDateString();
          const name = roomName + ' - ' + dateSelected;
          this.state.room_line_today.toolbox.feature.saveAsImage.name = name;
          this.state.room_line_day_of_month.toolbox.feature.saveAsImage.name = roomName;
        }
      });
    }
  }

  getRoomDevices(roomId) {
    ds.getDevicesInRoom(roomId,
      data => {
        if (data && data.length) {
          data.forEach((devicePresent) => {
            const deviceObj = {
              label: devicePresent.device_name,
              value: devicePresent.kd_id,
              deviceName: devicePresent.device_name,
            };
            options.push(deviceObj);
          });
        }
      },
      err => { }
    );
  }

  convertTime(timeStamp) {
    var time = new Date(timeStamp);
    var convertedTime = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    return convertedTime;
  }

  getSwitchesHistory() {
    const obj = {
      switch_id: this.state.current_switches.switches,
      date: this.state.ch_in_time
    };

    this.setState({
      showHistory: false
    });

    ds.postSwitchHistory(obj,
      data => {
        if (data && data.length) {
          let history = [];
          data.forEach((itemPresent) => {
            this.state.current_switches.switchesInfo.forEach((switchPresent) => {
              if (itemPresent._id.toString() == switchPresent._id.toString()) {
                const values = Object.values(itemPresent.switch_event).flat();
                if (values && values.length) {
                  values.forEach((valuePresent) => {
                    const obj = {
                      name: switchPresent.name,
                      timestamp: valuePresent.timestamp,
                      event_type: valuePresent.event_type,
                      actionTime: this.convertTime(valuePresent.timestamp)
                    };
                    history.push(obj)
                  });
                }
              }
            });
          });

          this.setState({
            switchHistory: history,
            showHistory: true
          });

        } else {
          this.setState({
            showHistory: true
          });
        }
      },
      err => { }
    );
  }

  changeCurrentIndex(ind) {
    options = [];

    this.setState({
      all_months: []
    });

    if (ind == -1) {
      ds.getDevicesInHotel(
        data => {
          if (data && data.map) {
            let devices = data.map((obj) => {
              return obj.kd_id
            })
            this.setState({
              current_devices: devices

            }, () => {
              this.getTodaysPower();
              this.setImageDetails(ind);

            });
          }
        }, err => { }
      );
    }
    else {
      this.getRoomDevices(ind);

      this.setImageDetails(ind);

      ds.getSwitchesInRoom(ind,
        data => {
          if (data.devicesInfo) {
            let devices = Object.keys(data.devicesInfo)
            let switchAppliances = {
              switches: [],
              switchesInfo: []
            };

            if (data && data.switchAppliances) {
              switchAppliances.switchesInfo = data.switchAppliances;

              data.switchAppliances.forEach((switchPresent) => {
                switchAppliances.switches.push(switchPresent._id);
              });
            }

            this.setState({
              current_devices: devices,
              current_switches: switchAppliances

            }, () => {
              this.getTodaysPower();
              this.getSwitchesHistory();
            });
          }
        }, err => { }
      );
    }
  }

  getTodaysPower() {
    let c = new Date(Date.now());
    let d = new Date(c);
    d.setHours(0, 0, 0, 0);

    this.getAMonthsPower(new Date(), 0);

    ds.postGetEnergyData(
      {
        "kd_id": this.state.current_devices,
        "timeto": c.getTime(),
        "timefrom": d.getTime(),
        "interval": "today"
      },
      data => {
        if (data.length) {
          //CHART
          if (data.length) {
            let chartData = [];
            let labels = [];
            let sorted_data;
            sorted_data = help.sorter(data, "_id", "");

            for (let i of sorted_data) {
              chartData.push(Math.round((i.avg_energy / 3600000) * 1000) / 1000);
              if (i._id < 12) {
                if (i._id == 0) {
                  labels.push('12AM - 1AM');
                }
                else {
                  const amLabel = i._id + 'AM - ' + (i._id + 1) + 'AM'
                  labels.push(amLabel);
                }
              }
              else {
                if (i._id == 12) {
                  labels.push('12PM - 1PM');
                }
                else {
                  const pmLabel = (parseInt(i._id) - 12).toString() + 'PM - ' + ((parseInt(i._id) - 12) + 1).toString() + 'PM'
                  labels.push(pmLabel);
                }
              }
            }

            let x = this.state.room_line_today;

            x.series[0].data = chartData;
            x.xAxis[0].data = labels;
            x.loading = false;

            this.setState({
              room_line_today: x,
              renderGraph: true
            });
          }

          //data = this.help.sorter(data, 'avg_energy', '')
          let x = 0;
          for (let i of data) {
            x += parseFloat(i.avg_energy);
          }
          if (x) {
            let room_energy = this.state.room_energy;
            room_energy = x;
            //this.home_energy = Math.round(this.home_energy * 100) / 100;
            room_energy = room_energy / 3600000;
            room_energy = Math.round(room_energy * 100) / 100;

            this.setState({
              room_energy: room_energy
            });
          }
        }
      }, error => { }
    );
  }

  getAMonthsPower(month, index) {
    month = new Date(month);
    let d = new Date(month);
    d.setHours(0, 0, 0, 0);
    d.setDate(1);
    ds.postGetPowerData(
      {
        "kd_id": this.state.current_devices,
        "timeto": month.getTime(),
        "timefrom": d.getTime(),
        "interval": "month"
      },
      data => {
        if (data.length) {

          let chartData = [];
          let labels = [];
          let sorted_data;
          sorted_data = help.sorter(data, "_id", "");
          for (let i of sorted_data) {
            chartData.push(i.avg_power);
            labels.push(i._id);
          }
          //let month_data = { ...CHART_TEMPLATE };
          let month_data = $.extend(true, {}, CHART_TEMPLATE);
          month_data.legend.data = [`Power Consumption in ${MONTH_NAMES[month.getMonth()]}`];
          month_data.xAxis[0].data = labels;
          month_data.series[0].data = chartData;
          let all_months = this.state.all_months;
          if (index != 0 || 1) {

            all_months.push({
              name: MONTH_NAMES[month.getMonth()],
              month: month.getMonth(),
              data: month_data
            });
          }

          ds.postGetEnergyData(
            {
              "kd_id": this.state.current_devices,
              "timeto": month.getTime(),
              "timefrom": d.getTime(),
              "interval": "month"
            },
            data => {
              all_months[index].energy_data = data

              this.setupDayWise(index);

              this.setState({
                all_months: all_months
              });

              if (all_months.length < MAX_MONTHS) {
                month = new Date(month.getFullYear(), month.getMonth(), 0);
                this.getAMonthsPower(month, index + 1);
              }
            },
            error => { }
          );
        }
      },
      error => { }
    );
  }

  getDataForADayOfMonth(item, day) {
    let year = new Date().getFullYear();
    let date = new Date().setDate(day.date, item.month, year);

    let name = this.state.room_line_day_of_month.toolbox.feature.saveAsImage.name;
    name = name + ' - ' + new Date(date).toDateString();
    this.state.room_line_day_of_month.toolbox.feature.saveAsImage.name = name;

    let timeFrom = new Date(date);
    timeFrom.setHours(0, 0, 0, 0);

    ds.postGetEnergyData(
      {
        kd_id: this.state.current_devices,
        timefrom: timeFrom.getTime(),
        interval: 'day',
        date: day.date,
        month: item.month
      },
      data => {
        if (data.length) {
          let chartData = [];
          let labels = [];
          let sorted_data;
          sorted_data = help.sorter(data, "_id", "");

          for (let i of sorted_data) {
            chartData.push(Math.round((i.avg_energy / 3600000) * 1000) / 1000);
            if (i._id < 12) {
              if (i._id == 0) {
                labels.push('12AM - 1AM');
              }
              else {
                const amLabel = i._id + 'AM - ' + (i._id + 1) + 'AM'
                labels.push(amLabel);
              }
            }
            else {
              if (i._id == 12) {
                labels.push('12PM - 1PM');
              }
              else {
                const pmLabel = (parseInt(i._id) - 12).toString() + 'PM - ' + ((parseInt(i._id) - 12) + 1).toString() + 'PM'
                labels.push(pmLabel);
              }
            }
          }

          let x = this.state.room_line_day_of_month;
          x.series[0].data = chartData;
          x.xAxis[0].data = labels;
          x.loading = false;

          this.setState({
            room_line_day_of_month: x,
          });

          let xEnergy = 0;
          for (let i of data) {
            xEnergy += parseFloat(i.avg_energy);
          }
          if (xEnergy) {
            let room_energy = 0;
            room_energy = xEnergy;
            room_energy = room_energy / 3600000;
            room_energy = Math.round(room_energy * 100) / 100;

            this.setState({
              dialog: {
                open: true,
                body:
                  <div>
                    <div>
                      Total Energy Consumed : <b>{room_energy} Units</b>
                      <RaisedButton
                        label="Export CSV"
                        primary
                        onClick={this.downloadCSV.bind(this, 'monthDay')}
                        type="button"
                        style={{float: 'right'}}
                      />
                    </div>
                    <br />
                    <br />
                    <ReactEcharts option={this.state.room_line_day_of_month} showLoading={false} />
                  </div>,
                actions: []
              }
            });
          }
        }
      }, error => { }
    );
  }

  setupDayWise(month) {
    let day_wise = [];
    let ind = 0;
    let all_months = this.state.all_months;
    for (let i of all_months[month].data.series[0].data) {
      let date = all_months[month].data.xAxis[0].data[ind];
      let sup_txt = 'th'
      if (date == 1 || date == 21 || date == 31) {
        sup_txt = 'st'
      }
      else if (date == 2 || date == 22) {
        sup_txt = 'nd'
      }
      else if (date == 3 || date == 23) {
        sup_txt = 'rd'
      }

      day_wise.push({
        power: Math.round(i * 100) / 100,
        date: date,
        sup_txt: sup_txt
      });
      ind++;
    }
    for (let i of all_months[month].energy_data) {

      for (let j of day_wise) {
        if (j.date == i._id) {
          if (i.avg_energy) {
            j.energy = i.avg_energy / 3600;
            j.energy = Math.round(j.energy * 100) / 100;
            break;
          }
        }
      }
    }
    all_months[month].day_wise = day_wise;
    all_months[month].total_energy = 0;
    for (let i of all_months[month].day_wise) {
      if (i.energy && parseFloat(i.energy)) {
        all_months[month].total_energy += i.energy;
      }
    }
    this.setState({
      all_months: all_months
    });
  }

  searchRooms() {
    if (this.state.search_field) {
      let x = this.state.all_rooms_copy.slice();
      let y = [];
      let searchString = this.state.search_field
      for (let obj of x) {
        if (obj && obj.hotel_room_id && obj.hotel_room_id.name) {
          let room = obj.hotel_room_id.name;
          if (room.toLowerCase().lastIndexOf(searchString.toLowerCase(), 0) === 0) {
            y.push(obj);
          }
        }
      }
      this.setState({
        all_rooms: y
      });
    }
    else {
      this.setState({
        all_rooms: this.state.all_rooms_copy.slice()
      });
    }
  }

  applyFilters() {
    var deviceIds = [];
    this.setState({
      renderGraph: false

    }, () => {
      if (this.state.devicesSelected && this.state.devicesSelected.length != '-1') {
        this.state.devicesSelected.forEach((item) => {
          deviceIds.push(item.value);
        });

        let filteredSwitches = [];

        this.state.devicesSelected.forEach((devicePresent) => {
          this.state.current_switches.switchesInfo.forEach((switchPresent) => {
            if (switchPresent.device_id.toString() == devicePresent.value.toString()) {
              filteredSwitches.push(switchPresent._id);
            }
          });
        });

        this.state.current_switches.switches = filteredSwitches;
      }

      this.setState({
        current_devices: deviceIds,

      }, () => {
        this.getTodaysPower();
        this.getSwitchesHistory();
      });
    });
  }

  downloadCSV(requestFrom, monthName= '') {
    let csvData = [];
		let fields = [ 'From Time', 'To Time', 'Energy Consumed' ];
    let fileName = '';

    if (requestFrom == 'today') {
      const energyData = this.state.room_line_today.series[0].data;
      this.state.room_line_today.xAxis[0].data.forEach((labelPresent, index) => {
        let csvObject = {};
        const splitArray = labelPresent.split('-');
        csvObject = {
          'From Time': splitArray[0],
          'To Time': splitArray[1],
          'Energy Consumed': energyData[index] + ' Units'
        };
        csvData.push(csvObject);

      });

      fileName = this.state.room_line_today.toolbox.feature.saveAsImage.name.concat('.csv');
      help.exportToCSV(csvData, fields, fileName);

    } else if (requestFrom == 'monthDay') {

      const energyData = this.state.room_line_day_of_month.series[0].data;
      this.state.room_line_day_of_month.xAxis[0].data.forEach((labelPresent, index) => {
        let csvObject = {};
        const splitArray = labelPresent.split('-');
        csvObject = {
          'From Time': splitArray[0],
          'To Time': splitArray[1],
          'Energy Consumed': energyData[index] + ' Units'
        };
        csvData.push(csvObject);

      });

      fileName = this.state.room_line_day_of_month.toolbox.feature.saveAsImage.name.concat('.csv');

      help.exportToCSV(csvData, fields, fileName);

    } else if (requestFrom == 'monthData') {
      let energyData = [];

      fields = ['Date', 'Average Power', 'Energy']
      fileName = `${monthName}PowerConsumption.csv`;
      this.state.all_months.forEach((monthPresent) => {
        if (monthPresent.name.toString() == monthName.toString()) {
          energyData = monthPresent.day_wise;
        }
      });

      if (energyData && energyData.length) {
        energyData.forEach((energyPresent) => {
          let csvObject = {};
          csvObject = {
            Date: energyPresent.date,
            'Average Power': energyPresent.power ? energyPresent.power + ' W' : 'NA',
            Energy: energyPresent.energy ? (Math.round((parseFloat(energyPresent.energy ) / 1000) * 1000) / 1000)+ ' Units' : 'NA'
          };
          csvData.push(csvObject);
        });
        help.exportToCSV(csvData, fields, fileName);
      }
    }
  }

  render() {
    return (
      <div className="col-md-12">
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <section className="box box-default customBox col-md-3 mt-4">
          <div className="box-header">
            Rooms
            <section>
              <TextField
                floatingLabelText="Search Room"
                className="w-100"
                value={this.state.search_field}
                onChange={(e) => {
                  this.setState({
                    search_field: e.target.value
                  }, () => {
                    this.searchRooms();
                  });
                }}
              />
            </section>
          </div>

          <div className="box-body" style={{ paddingTop: "0px" }}>
            <SelectableList currentIndexGetter={this.changeCurrentIndex.bind(this)}>
              <Subheader>Select a Room</Subheader>
              <ListItem
                key="dude"
                value={-1}
                primaryText="All"
              />
              {
                this.state.all_rooms.map((row, index) => {
                  return (
                    <ListItem
                      key={row._id}
                      value={row.hotel_room_id ? row.hotel_room_id._id : null}
                      primaryText={row.hotel_room_id ? row.hotel_room_id.name : ''}
                    />
                  )
                })
              }
            </SelectableList>
          </div>
        </section>

        {
          this.state.current_devices && this.state.current_devices.length ?
            <div>
              <div className="container-fluid no-breadcrumbs zeroPadding">
                <div className="row">
                  <div className="col-xl-12 pr-0px">
                    <div className="box box-default customBox" style={{ marginTop: '-0.5rem' }}>
                      <div className="box-heading">
                        Today's Power Consumption
                        <span style={{ float: "right" }}>
                          Total Energy Consumed : {this.state.room_energy ? this.state.room_energy + ' Units' : 'NA'}
                        </span>
                      </div>

                      <div style={{ float: "right", zIndex: '11' }} className="col-sm-6">
                        <div className="col-sm-12 zeroPadding">
                          <div className="col-sm-8 zeroPadding">
                            <Select
                              id="device_id"
                              onBlurResetsInput={false}
                              onSelectResetsInput={false}
                              autoFocus
                              options={options}
                              searchable={true}
                              placeholder="Select Devices"
                              multi={true}
                              value={this.state.devicesSelected}
                              onChange={(newValue) => {
                                this.setState({
                                  devicesSelected: newValue,
                                });
                              }}
                            />
                          </div>

                          <div className="col-sm-4">
                            <RaisedButton
                              label="Apply"
                              primary
                              onClick={this.applyFilters.bind(this)}
                              type="button"
                            />
                          </div>
                        </div>
                      </div>

                      <br />
                      <br />

                      {
                        this.state.renderGraph && 
                        this.state.room_line_today.series[0].data && 
                        this.state.room_line_today.series[0].data.length?
                          <div className="box-body">
                            <ReactEcharts option={this.state.room_line_today} showLoading={false} />
                            
                            <br />
                            <br />

                            <RaisedButton
                              label="Export CSV"
                              primary
                              onClick={this.downloadCSV.bind(this, 'today')}
                              type="button"
                              style={{float: 'right'}}
                            />
                          </div>

                        : <p className="text-center mt-1rem pb-1rem"> No Graph Present! </p>
                      }
                    </div>

                    {
                      this.state.showHistory ?
                        <div className="box box-default customBox" style={{ marginTop: '-0.5rem' }}>
                          <div className="box-heading">Today's Switch History</div>
                          <div style={{ float: "right", zIndex: '11' }} className="col-sm-4">
                        <div className="col-sm-12 zeroPadding">
                        <DatePicker
                      hintText="Check-in Date"
                      container="inline"
                      name="ch_in_time"
                     // className="col-sm-5 w-100"
                      maxDate={this.state.maxDate}
                      value={this.state.ch_in_time}
                      autoOk
                      // style={{
                      //   maxWidth: '50%'
                      // }}
                      onChange={(e, value) => {
                        this.setState({
                          ch_in_time: value
                        },()=>{
                          this.getSwitchesHistory()
                        })
                      }} 
                    />
                        </div>
                      </div>
                         
                            {
                              this.state.switchHistory && this.state.switchHistory.length ?
                              <div  className="box-body">
                                <Table
                                  height={'45vh'}
                                  fixedHeader={true}
                                  fixedFooter={true}
                                  selectable={false}
                                  multiSelectable={false}
                                  bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
                                >

                                  <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                      <TableHeaderColumn tooltip="Switch Name">Name</TableHeaderColumn>
                                      <TableHeaderColumn tooltip="TimeStamp">Time</TableHeaderColumn>
                                      <TableHeaderColumn tooltip="Action">Action</TableHeaderColumn>
                                    </TableRow>
                                  </TableHeader>

                                  <TableBody
                                    displayRowCheckbox={false}
                                    showRowHover={true}
                                    stripedRows={false}
                                  >
                                    {
                                      this.state.switchHistory.map((row, index) => (
                                        <TableRow key={index}>
                                          <TableRowColumn style={{ overflow: 'visible' }}>
                                            {row.name}
                                          </TableRowColumn>

                                          <TableRowColumn style={{ overflow: 'visible' }}>
                                            {
                                              row.timestamp && row.actionTime ?
                                                row.actionTime

                                              : 'NA'
                                            }
                                          </TableRowColumn>

                                          <TableRowColumn style={{ overflow: 'visible' }}>
                                            {
                                              row.event_type == 0 ? 'OFF' : 'ON'
                                            }
                                          </TableRowColumn>
                                        </TableRow>
                                      ))
                                    }
                                  </TableBody>
                                </Table>
                                </div>

                              : <div style={{ marginTop: '4rem'}}>
                                <p className="text-center mt-1rem pb-1rem"> No History Present! </p>
                                </div>
                            }
                         
                        </div>
                      : null
                    }
                  </div>
                </div>
              </div>

              <div>
                <Tabs
                  onChange={(e) => {
                    this.setState({
                      slideIndex: e
                    })
                  }}
                  value={this.state.slideIndex}>
                  {
                    this.state.all_months && this.state.all_months.length ?
                      this.state.all_months.map((obj, ind) => {
                        return <Tab label={obj.name} value={ind} key={ind} />
                      })
                    : null
                  }
                </Tabs>

                <SwipeableViews
                  index={this.state.slideIndex}
                  onChangeIndex={(e) => {
                    this.setState({
                      slideIndex: e
                    });
                  }}
                >
                  {
                    this.state.all_months && this.state.all_months.length ?
                      this.state.all_months.map((obj, ind) => {
                        return <div>
                          <div className="box box-default col-md-7">
                            <div className="box-heading">Power Consumption in {obj.name}'
                              <RaisedButton
                                label="Export CSV"
                                primary
                                onClick={this.downloadCSV.bind(this, 'monthData', obj.name)}
                                type="button"
                                style={{float: 'right'}}
                              />
                            </div>
                            <div className="box-heading font-2rem primary-fg">{obj.total_energy && parseFloat(obj.total_energy) ? (Math.round((parseFloat(obj.total_energy) / 1000) * 1000) / 1000) + " Units" : ''}</div>

                            <br/>
                            <br/>

                            <div className="box-body">
                              <ReactEcharts option={obj.data} showLoading={false} />
                            </div>
                          </div>
                          {
                            obj.day_wise && obj.day_wise.length ?
                              <div className="col-md-5">
                                <Table
                                  height={'330px'}
                                  fixedHeader={true}
                                  fixedFooter={true}
                                  selectable={false}
                                  multiSelectable={false}
                                >
                                  <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                      <TableHeaderColumn colSpan="3" className="align-center">
                                        Day Wise Power Consumption in {obj.name}
                                      </TableHeaderColumn>
                                    </TableRow>

                                    <TableRow>
                                      <TableHeaderColumn tooltip="Date">Date</TableHeaderColumn>
                                      <TableHeaderColumn tooltip="Average Power consumed in Watts">Avg. Power (W)</TableHeaderColumn>
                                      <TableHeaderColumn tooltip="Energy Consumed in Watt-Hours">Energy (Units)</TableHeaderColumn>
                                    </TableRow>
                                  </TableHeader>

                                  <TableBody
                                    displayRowCheckbox={false}
                                    showRowHover={true}
                                    stripedRows={false}
                                  >
                                    {
                                      obj.day_wise.map((row, index) => (
                                        <TableRow key={index} style={{ cursor: 'pointer' }}>
                                          <TableRowColumn>
                                            <div onClick={this.getDataForADayOfMonth.bind(this, obj, row)}>
                                              {row.date}<sup>{row.sup_txt}</sup>
                                            </div>
                                          </TableRowColumn>

                                          <TableRowColumn>
                                            <div onClick={this.getDataForADayOfMonth.bind(this, obj, row)}>
                                              {row.power} W
                                            </div>
                                          </TableRowColumn>

                                          <TableRowColumn>
                                            {
                                              row.energy && parseFloat(row.energy) ?
                                                <div onClick={this.getDataForADayOfMonth.bind(this, obj, row)}>
                                                  {
                                                    (Math.round((parseFloat(row.energy) / 1000) * 1000) / 1000) + " Units"
                                                  }
                                                </div>

                                              : 'NA'
                                            }
                                          </TableRowColumn>
                                        </TableRow>
                                      ))
                                    }
                                  </TableBody>
                                </Table>
                              </div>
                            : null
                          }
                        </div>
                      })
                    : null
                  }
                </SwipeableViews>
              </div>
            </div>
          : 
          <div className="container-fluid no-breadcrumbs zeroPadding">
            <p className="text-center mt-1rem"> No Data Present! </p>
          </div>
        }
      </div>
    )
  }
}

let SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {
  return class SelectableList extends React.Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
    };

    componentWillMount() {
      this.setState({
        selectedIndex: this.props.defaultValue,
      });
    }

    handleRequestChange = (event, index) => {
      this.setState({
        selectedIndex: index,
      }, () => {
        this.props.currentIndexGetter(this.state.selectedIndex);
      });
    };

    render() {
      return (
        <ComposedComponent
          value={this.state.selectedIndex}
          onChange={this.handleRequestChange}
        >
          {this.props.children}
        </ComposedComponent>
      );
    }
  };
}

SelectableList = wrapState(SelectableList);


// WEBPACK FOOTER //
// ./components/power/RoomPower.js